<template>
  <div class="question-container">
    <p v-if="uptitle" class="question-container__uptitle">{{ uptitle }}</p>
    <h3 class="question-container__title">{{ index }}. {{ title }}</h3>
    <p class="question-container__description">{{ description }}</p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: [Number, String],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    uptitle: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.question-container {
  margin-bottom: 32px;
  padding-bottom: 16px;
  border-bottom: 1px solid #E2E6EA;

  &__title {
    font-size: 18px;
    line-height: 21px;
    color: $main--text;
    font-weight: 600;
    margin-bottom: 8px;
  }

  &__uptitle {
    font-size: 12px;
    line-height: 14px;
    color: $main--text;
    opacity: 0.7;
    font-weight: 600;
    margin-bottom: 4px;
  }

  &__description {
    font-size: 14px;
    line-height: 16px;
    color: $main--text;
    opacity: 0.7;
  }
}
</style>
